document.addEventListener( 'DOMContentLoaded', () => {
	document.querySelectorAll( '[data-collapse]' ).forEach( ( block ) => {
		const trigger = block.querySelector( '.req-collapse-block__toggle' );
		const content = block.querySelector( '.req-collapse-block__content' );

		if ( ! trigger || ! content ) {
			return;
		}

		trigger.addEventListener( 'click', () => {
			const isOpen = block.classList.toggle( 'is-open' );

			trigger.setAttribute( 'aria-expanded', String( isOpen ) );
			content.hidden = ! isOpen;
		} );
	} );
} );
